// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ry-0";